const styles = theme => ({
  portrait: {},

  landscape: {},
  isFullscreen: {
    '& $speedDial': {
      marginRight: theme.spacing(3)
    }
  },
  donateButtons: {
    '&:focus': {
      outline: 'white solid 4px'
    },
    marginLeft: '20px',
    marginRight: '20px',
    padding: theme.spacing(4.5, 0),
    width: '100%',
    '@media (max-width: 1024px)': {
      padding: theme.spacing(2)
    },
    '&$portrait': {
      '@media (max-width: 1023px)': {
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative',
        justifyContent: 'space-between',
        '& $helpText': {
          marginBottom: 0
        }
      },
      '@media (max-width: 767px)': {
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative',
        justifyContent: 'space-between',
        '& $donateOption': {
          padding: 0,
          minWidth: 'initial'
        },
        '& $blueBox': {
          top: 0
        },
        '& $form': {
          flexDirection: 'column'
        },
        '& $confirmText': {
          marginBottom: theme.spacing(2),
          textAlign: 'center'
        }
      }
    }
  },
  donateButtonsBox: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    zIndex: 1,
    '@media (min-width: 1023px)': {
      paddingRight: theme.spacing(2)
    }
  },
  buttons: {
    '@media (max-width: 1024px)': {
      flexDirection: 'column'
    }
  },
  amountButtons: {
    '&:focus': {
      outline: 'white solid 4px'
    },
    '@media (max-width: 1024px)': {
      display: 'flex',
      marginBottom: theme.spacing(2),
      '& $donateOption': {
        flexGrow: 1
      }
    }
  },
  donateWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
    zIndex: 1
  },
  donateOption: {
    flexGrow: 0,
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1)
  },
  howToDonate: {
    color: 'white',
    fontFamily: 'Poppins',
    fontSize: 20,
    transition: 'filter 800ms ease-in-out'
  },
  form: {
    display: 'flex',
    alignItems: 'center'
  },
  textField: {
    top: 6,
    marginRight: theme.spacing(2)
  },
  inputRoot: {
    color: 'white'
  },
  inputUnderline: {
    '&:before': {
      borderColor: ['white', '!important']
    },
    '&:after': {
      borderColor: ['white', '!important']
    }
  },
  formHelperError: {
    color: ['white', '!important']
  },
  blueBox: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: theme.palette.secondary.main,
    color: 'white',
    padding: theme.spacing(4),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'all',
    zIndex: 2
  },
  confirmText: {
    fontSize: '1.55rem',
    marginRight: theme.spacing(2),
    lineHeight: '1.6rem'
  },
  confirmButton: {
    '&:focus': {
      outline: 'white solid 4px'
    },
    background: 'white',
    color: theme.palette.secondary.main,
    borderRadius: '20px',
    fontSize: '1.2rem',
    textTransform: 'capitalize',
    padding: '6px 36px',
    height: '42px',
    margin: '10px'
  },
  closeConfirmButton: {
    '&:focus': {
      outline: 'white solid 4px'
    },
    position: 'absolute',
    right: theme.spacing(),
    top: theme.spacing(),
    color: 'white'
  },
  speedDial: {},
  tooltip: {
    display: ['none', '!important']
  },
  //straight up just the css from the old bid buttons in order to keep everything consistent without
  //changing variable names
  hiddenTextField: {
    height: 0,
    width: 0,
    color: 'transparent'
  },
  helpText: {},
  noHover: {
    '&:hover': {
      backgroundColor: [theme.palette.secondary.main, '!important']
    }
  },
  winning: {
    color: 'white',
    width: '100%',
    textAlign: 'center',
    fontSize: '40px',
    '@media (max-width: 1024px)': {
      fontSize: '1.4rem'
    }
  },
  helpTextContainer: {
    minHeight: theme.spacing(3) + 130,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingTop: theme.spacing(3)
  },
  gradientBlue: {
    backgroundImage: `linear-gradient(transparent 0%, ${theme.palette.gradientColors.blue})`
  },
  gradientGreen: {
    backgroundImage: `linear-gradient(transparent 0%, ${theme.palette.gradientColors.green})`
  },
  gradientGrey: {
    backgroundImage: `linear-gradient(transparent 0%, ${theme.palette.gradientColors.grey})`
  },
  bidTextButton: {
    paddingRight: '15px',
    paddingLeft: '15px',
    '@media (max-width: 1024px)': {
      height: 44,
      fontSize: 22,
      width: 'auto',
      paddingRight: '0px',
      paddingLeft: '0px'
    }
  },
  closeButton: {
    '&:focus': {
      outline: 'white solid 4px'
    },
    right: '-66vw',
    flexGrow: 0,
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    color: 'white',
    height: 56,
    minWidth: '150px',
    fontSize: 27,
    borderRadius: 30,
    '@media (max-width: 1024px)': {
      height: 44,
      fontSize: 22
    },
    '&:hover': {
      flexGrow: 0,
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      color: 'white',
      height: 56,
      fontSize: 27,
      borderRadius: 30,
      '@media (max-width: 1024px)': {
        height: 44,
        fontSize: 22
      }
    }
  },
  closeButtonDiv: {
    '&:focus': {
      outline: 'white solid 4px'
    },
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '100%',
    padding: theme.spacing(4.5, 0),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
    zIndex: 1,
    '@media (max-width: 1024px)': {
      padding: theme.spacing(2)
    },
    '&$portrait': {
      '@media (max-width: 1023px)': {
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative',
        justifyContent: 'space-between',
        '& $helpText': {
          marginBottom: 0
        }
      },
      '@media (max-width: 1022px)': {
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative',
        '& $helpText': {
          marginBottom: theme.spacing(3)
        }
      }
    },
    '&:hover': {
      padding: theme.spacing(4.5, 0),
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      position: 'relative',
      zIndex: 1,
      '@media (max-width: 1024px)': {
        padding: theme.spacing(2)
      },
      '&$portrait': {
        '@media (max-width: 1023px)': {
          flexDirection: 'row',
          justifyContent: 'space-between',
          '& $helpText': {
            marginBottom: 0
          }
        },
        '@media (max-width: 767px)': {
          flexDirection: 'column',
          '& $helpText': {
            marginBottom: theme.spacing(3)
          }
        }
      }
    }
  },
  bidAnonDiv: {
    '&:focus': {
      outline: 'white solid 4px'
    },
    float: 'right',
    height: '50%',
    width: 'auto',
    paddingRight: '200px',
    '@media (max-width: 767px)': {
      paddingRight: '10px',
      flexDirection: 'column',
      '& $helpText': {
        marginBottom: theme.spacing(3)
      }
    },
    padding: theme.spacing(4.5, 0),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
    zIndex: 1,
    '@media (max-width: 1024px)': {
      padding: theme.spacing(2)
    },
    '&$portrait': {
      '@media (max-width: 1023px)': {
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative',
        justifyContent: 'space-between',
        '& $helpText': {
          marginBottom: 0
        }
      },
      '@media (max-width: 767px)': {
        flexDirection: 'column',
        '& $helpText': {
          marginBottom: theme.spacing(3)
        }
      }
    },
    '&:hover': {
      padding: theme.spacing(4.5, 0),
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      position: 'relative',
      zIndex: 1,
      '@media (max-width: 1024px)': {
        padding: theme.spacing(2)
      },
      '&$portrait': {
        '@media (max-width: 1023px)': {
          flexDirection: 'row',
          justifyContent: 'space-between',
          '& $helpText': {
            marginBottom: 0
          }
        },
        '@media (max-width: 767px)': {
          flexDirection: 'column',
          '& $helpText': {
            marginBottom: theme.spacing(3)
          }
        }
      }
    }
  },
  bidDiv: {
    float: 'left',
    height: '50%',
    width: 'auto',
    paddingLeft: '200px',
    '@media (max-width: 767px)': {
      paddingRight: '10px',
      flexDirection: 'column',
      '& $helpText': {
        marginBottom: theme.spacing(3)
      }
    },
    padding: theme.spacing(4.5, 0),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
    zIndex: 1,
    '@media (max-width: 1024px)': {
      padding: theme.spacing(2)
    },
    '&$portrait': {
      '@media (max-width: 1023px)': {
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative',
        justifyContent: 'space-between',
        '& $helpText': {
          marginBottom: 0
        }
      },
      '@media (max-width: 767px)': {
        flexDirection: 'column',
        '& $helpText': {
          marginBottom: theme.spacing(3)
        }
      }
    },
    '&:hover': {
      padding: theme.spacing(4.5, 0),
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      position: 'relative',
      zIndex: 1,
      '@media (max-width: 1024px)': {
        padding: theme.spacing(2)
      },
      '&$portrait': {
        '@media (max-width: 1023px)': {
          flexDirection: 'row',
          justifyContent: 'space-between',
          '& $helpText': {
            marginBottom: 0
          }
        },
        '@media (max-width: 767px)': {
          flexDirection: 'column',
          '& $helpText': {
            marginBottom: theme.spacing(3)
          }
        }
      }
    }
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/EngagementButtons/BidButton/styles.js